
import {createWidget, Widget} from '@typeform/embed'
import {html, LitElement} from "lit";
import {WlModal} from "../modal/modal.component";
import {PropertyValues} from "@lit/reactive-element";

export class WLTypeformModal extends LitElement {
    private formId: string = "";
    private hiddenFields: Record<string, string> = {};
    private fullscreen: boolean = false;
    private closeTimeout: number = 0;

    private modal : WlModal | null = null;
    private form: HTMLElement | null = null;
    private _widget : Widget | null = null;

    static get properties() {
        return {
            formId: {type: String, attribute: "form-id"},
            fullscreen: {type: Boolean},
            closeTimeout: {type: Number, attribute: "close-timeout"},
        }
    }

    open() {
        if (!this._widget) {
            this._widget = createWidget(this.formId, {
                container: this.form!!,
                onSubmit: () => {
                    setTimeout(() => this.modal!!.close(), this.closeTimeout)
                },
                hidden: this.hiddenFields,
                hideHeaders: true,
                hideFooter: true,
                autoResize: true,
                opacity: 0,
                inlineOnMobile: true,
            })
        }
        this.modal!!.fullscreen = this.fullscreen
        this.modal!!.open();
    }

    protected render() {
        return html`
            <link rel="stylesheet" href="https://embed.typeform.com/next/css/widget.css" />
            <wl-modal id="modal" ${this.fullscreen ? "fullscreen" : ""}>
                <div id="form" style="min-height:700px;border:none;"></div>
            </wl-modal>
        `;
    }

    protected firstUpdated(_changedProperties: PropertyValues) {
        super.firstUpdated(_changedProperties)
        this.modal = this.renderRoot.querySelector<WlModal>("#modal");
        this.form = this.renderRoot.querySelector("#form");
    }
}

customElements.define('wl-typeform-modal', WLTypeformModal);